import { createLowlight } from 'lowlight';
import bash from 'highlight.js/lib/languages/bash';
import cpp from 'highlight.js/lib/languages/cpp';
import css from 'highlight.js/lib/languages/css';
import go from 'highlight.js/lib/languages/go';
import xml from 'highlight.js/lib/languages/xml';
import java from 'highlight.js/lib/languages/java';
import javascript from 'highlight.js/lib/languages/javascript';
import json from 'highlight.js/lib/languages/json';
import markdown from 'highlight.js/lib/languages/markdown';
import php from 'highlight.js/lib/languages/php';
import python from 'highlight.js/lib/languages/python';
import rust from 'highlight.js/lib/languages/rust';
import sql from 'highlight.js/lib/languages/sql';
import typescript from 'highlight.js/lib/languages/typescript';
import yaml from 'highlight.js/lib/languages/yaml';

// Instanță lowlight cu limbajele pre-înregistrate — reutilizată la fiecare
// mount al editor-ului (evităm re-registrare costisitoare).
export const cerbesLowlight = createLowlight();
cerbesLowlight.register('bash', bash);
cerbesLowlight.register('shell', bash);
cerbesLowlight.register('sh', bash);
cerbesLowlight.register('cpp', cpp);
cerbesLowlight.register('c++', cpp);
cerbesLowlight.register('c', cpp); // C share-uiește destul cu C++ pentru highlight
cerbesLowlight.register('css', css);
cerbesLowlight.register('go', go);
cerbesLowlight.register('html', xml);
cerbesLowlight.register('xml', xml);
cerbesLowlight.register('java', java);
cerbesLowlight.register('javascript', javascript);
cerbesLowlight.register('js', javascript);
cerbesLowlight.register('json', json);
cerbesLowlight.register('markdown', markdown);
cerbesLowlight.register('md', markdown);
cerbesLowlight.register('php', php);
cerbesLowlight.register('python', python);
cerbesLowlight.register('py', python);
cerbesLowlight.register('rust', rust);
cerbesLowlight.register('rs', rust);
cerbesLowlight.register('sql', sql);
cerbesLowlight.register('typescript', typescript);
cerbesLowlight.register('ts', typescript);
cerbesLowlight.register('yaml', yaml);
cerbesLowlight.register('yml', yaml);
